import { AppScheme } from "@fe_utils/fe_sdk_base";

export const appInfoList = [
  {
    appName: "时刻守护",
    scheme: AppScheme.Findyou,
    appIcon: "https://cdn.quthing.com/laiyin_shikeshouhu_logo_icon.webp",
    appIntro: "情侣亲友实时位置共享App ",
    rate: 4.8,
    rateNumbers: "26w+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“用这款软件一年多了，定位一直很精准，下载来保护孩子的，随时知道孩子位置，上学放学都知道，很放心。” ——怎么不会额",
      "“定位很准确，推荐异地的情侣或者朋友使用，能自动记每天的移动轨迹，好友可以随时看到，来确认对方安全，很棒的一款应用，会一直使用，推荐推荐！” ——玉米侠小汤圆",
    ],
  },
  {
    appName: "灵敢足迹",
    scheme: AppScheme.Xihangfootprint,
    appIcon: "https://cdn.quthing.com/laiyin_zuji_logo_icon.webp",
    appIntro: "全自动记录旅行轨迹和生活足迹",
    rate: 4.8,
    rateNumbers: "5w+个评分",
    awards: [
      {
        name: "首页推荐",
        device: "OPPO",
        gold: false,
      },
      {
        name: "繁星计划",
        device: "VIVO",
        gold: false,
      },
      {
        name: "每日精选",
        device: "华为",
        gold: false,
      },
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
    ],
    comments: [
      "“朋友推荐的，出去旅游自动记录旅游路线，还可以看海拔，真的很爱。看自己去过的城市，走过的街道，很有纪念意义。” ——美657",
      "“好用，省电，打开后几乎不用管自动记录，并且视觉效果也很好。” ——liyn65",
    ],
  },
  {
    appName: "灵敢提词器",
    scheme: AppScheme.Laiyinprompt,
    appIcon: "https://cdn.quthing.com/laiyin_ticiqi_logo_icon.webp",
    appIntro: "口播演讲，提词同时拍摄的软件",
    rate: 4.8,
    rateNumbers: "16w+个评分",
    awards: [
      {
        name: "新锐榜单",
        device: "荣耀",
        gold: false,
      },
      {
        name: "首页推荐",
        device: "OPPO",
        gold: false,
      },
    ],
    comments: [
      "“喜欢玩抖音，直播需要会说话，但是我记不得台词，有了这个提词器就不怕了，照着读就好了，字幕滚动速度还能调节，挺好的，感谢开发者为我们这些没记性的提供了好的软件，本人非常喜欢感谢🙏感谢” ——温馨有家家政",
      "“真的好用 ，太多字了背不下来，背下来了又怕卡顿，用这个别人都看不出来我用了提词器，好好用” ——123（后海鲜",
    ],
  },
  {
    appName: "灵敢文案提取",
    scheme: AppScheme.Copywriting,
    appIcon: "https://static.quthing.com/fe/img/base/copywriting_logo.png",
    appIntro: "全能自媒体文案提取编辑神器，一键提取快速创作",
    rate: 4.9,
    rateNumbers: "4000+个评分",
    awards: [],
    comments: [
      "“好用流畅，取文快速准确，还有其他方面的作用非常广泛，是创作者的好助手，值得拥有。” ——༺ཌༀ 涅槃 ༀད༻",
      "“软件非常强大，支持视频连接图片转文字，而且会智能生成文案，确实是一款非常好的一个提词软件，鼓励大家下载。”——谜底无悔",
    ],
  },
];

export const coreTeamList = [
  {
    url: require("../../components/images/CEO_card_bg.png"),
    name: "李帅",
    position: "CEO",
    contentList: [
      "毕业于华中科技大学计算机系",
      "中国早期移动端技术专家",
      "曾任美团iOS技术团队负责人",
      "曾任美团技术委员会成员",
      "连续成功创业者",
      "连续6年获聘“北京市创业导师”",
    ],
  },
  {
    url: require("../../components/images/CTO_card_bg.png"),
    name: "周志华",
    position: "CTO",
    contentList: [
      "全面负责技术创新研究",
      "毕业于东北师大软件工程系",
      "连续成功创业者",
      "全栈技术大神",
      "曾为人人游戏搭建承载千万级用户技术框架",
    ],
  },
  {
    url: require("../../components/images/CPO_card_bg.png"),
    name: "马钊",
    position: "CPO",
    contentList: [
      "全面负责公司产品及移动端技术方向把控",
      "毕业于吉林大学软件工程系",
      "曾任美团产品技术委员会常委",
      "曾任美团金融业务负责人",
    ],
  },
];
